// Twelve pins, a package and a die, on the same 28×28 grid as its siblings.
// Grouped so the fill is stated once rather than on all fourteen paths.
export const cpu = (
  <g fill="currentColor">
    {/* Pins: three per side. */}
    <path d="M14.833 23.3333V26.3333H13.167V23.3333H14.833Z" />
    <path d="M14.833 1.66998V4.66998H13.167V1.66998H14.833Z" />
    <path d="M20.6663 23.3333V26.3333H19.0003V23.3333H20.6663Z" />
    <path d="M20.6663 1.66998V4.66998H19.0003V1.66998H20.6663Z" />
    <path d="M4.67 13.167V14.833H1.67V13.167H4.67Z" />
    <path d="M4.67 19.0003V20.6663H1.67V19.0003H4.67Z" />
    <path d="M4.67 7.33368V8.99969H1.67V7.33368H4.67Z" />
    <path d="M26.3333 13.167V14.833H23.3333V13.167H26.3333Z" />
    <path d="M26.3333 19.0003V20.6663H23.3333V19.0003H26.3333Z" />
    <path d="M26.3333 7.33368V8.99969H23.3333V7.33368H26.3333Z" />
    <path d="M8.99968 23.3333V26.3333H7.33366V23.3333H8.99968Z" />
    <path d="M8.99968 1.66998V4.66998H7.33366V1.66998H8.99968Z" />

    {/* Package and die, both hollow — the counters are cut by the winding of
        the subpaths, so no fill rule is needed. */}
    <path d="M23 4L24 5V23L23 24H5L4 23V5L5 4H23ZM6 22H22V6H6V22Z" />
    <path d="M18 9L19 10V18L18 19H10L9 18V10L10 9H18ZM11 17H17V11H11V17Z" />
  </g>
);
